import {SerializedError} from "@reduxjs/toolkit";
import {FetchBaseQueryError} from "@reduxjs/toolkit/query";

export const getRtkQueryNonFieldErrorMessage = (error: FetchBaseQueryError | SerializedError | undefined): string | undefined => {
    if (!error || !("data" in error) || !error.data || typeof error.data !== "object") return undefined;

    const nonFieldErrors = "non_field_errors" in error.data ? (error.data as {non_field_errors?: string[]}).non_field_errors : undefined;

    return nonFieldErrors?.[0];
};
import {SerializedError} from "@reduxjs/toolkit";
import {FetchBaseQueryError} from "@reduxjs/toolkit/query";

export const getRtkQueryNonFieldErrorMessage = (error: FetchBaseQueryError | SerializedError | undefined): string | undefined => {
    if (!error || !("data" in error) || !error.data || typeof error.data !== "object") return undefined;

    const nonFieldErrors = "non_field_errors" in error.data ? (error.data as {non_field_errors?: string[]}).non_field_errors : undefined;

    return nonFieldErrors?.[0];
};
